import { Link, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../kontext/AuthKontext";
import { FehlerGrenze } from "./FehlerGrenze";

/** Rahmen des Installateur-Portals: schlicht und fürs Handy gebaut. */
export function PortalLayout() {
  const { benutzer, abmelden } = useAuth();
  const ort = useLocation();
  return (
    <div className="min-h-screen bg-neutral-50">
      <header className="sticky top-0 z-30 border-b border-neutral-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-3xl items-center gap-3 px-4">
          <Link to="/portal" aria-label="AnmeldeMeister – Portal-Startseite" className="shrink-0">
            <img src="/logo.png" alt="AnmeldeMeister" className="h-5 w-auto" />
          </Link>
          <span className="hidden min-w-0 truncate text-sm text-neutral-600 sm:inline">{benutzer?.betrieb?.name}</span>
          <button type="button" onClick={abmelden} className="ml-auto rounded-lg px-3 py-2 text-sm font-semibold text-neutral-700 hover:bg-neutral-100">
            Abmelden
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-6">
        <FehlerGrenze key={ort.pathname}>
          <Outlet />
        </FehlerGrenze>
      </main>
    </div>
  );
}
